import React from "react";

const MessageParser = ({ children, actions, state, ...rest }) => {
  const parse = (message) => {
    return actions.handleBotReply(message);
  };

  return (
    <div>
      {React.Children.map(children, (child) => {
        return React.cloneElement(child, {
          parse: parse,
          actions: {},
        });
      })}
    </div>
  );
};

export default MessageParser;
